import './license-agreement.scss';
import InstallerResource from '../../blocks/resource/resource';
import 'angular-sanitize';

class LicenseAgreementsController {
  /*@ngInject*/
  constructor($location, licenseAgreementsResource, $routeParams) {
    this.$location = $location;

    this.licenseAgreements = licenseAgreementsResource;

    if (this.licenseAgreements.length === 1) {
      this.openLicense(this.licenseAgreements[0]);
    }

    if ($routeParams.service) {
      const license = this.licenseAgreements.filter(l => l.productName === $routeParams.service)[0];
      this.openLicense(license);
    }
  }

  openLicense(license) {
    this.displayLicense = license;
    this.$location.search('service', license.productName);
  }
}

export default angular.module('installer.licenseAgreements', ['ngSanitize', InstallerResource.name]).
  controller('LicenseAgreementsController', LicenseAgreementsController).
  factory('LicenseAgreementsResourcePromise', installerResource => installerResource.licenseAgreements.query().$promise.then(function onSuccess(licenseAgreementsResource) {
    return licenseAgreementsResource;
  })).
  config($routeProvider => {
    $routeProvider.
      when('/license-agreements', {
        template: require('./license-agreement.html'),
        controller: 'LicenseAgreementsController as ctrl',
        resolve: {
          licenseAgreementsResource: 'LicenseAgreementsResourcePromise'
        }
      });
  });



// WEBPACK FOOTER //
// ./src/pages/license-agreement/license-agreement.js